import {
  CHECK_ACC_REQUESTING,
  CHECK_ACC_REQUEST_ERROR,
  CHECK_ACC_REQUEST_SUCCESS,
  DATA_ACCOUNT_SET,
} from "./constants";

const initialSate = {
  toast: null,
  dataAccount: null,

  checkAccount: null,
  checkAccountRequesting: false,
  checkAccountSuccessful: false,
  checkAccountErrors: [],
};

const reducer = function clientReducer(state = initialSate, action) {
  switch (action.type) {
    case "API_ERR":
    case "REQUEST_PRIVATE_FALSE":
      return {
        ...state,
        toast: {
          msg: action.resData?.msg || action.msg,
          title: "Thông báo",
          type: "error",
        },
      };
    case "SHOW_TOAST":
      return {
        ...state,
        toast: action.resData,
      };

    case "CLEAR_TOAST":
      return {
        ...state,
        toast: null,
      };

    case DATA_ACCOUNT_SET:
      return {
        ...state,
        dataAccount: action.resData,
      };

    case CHECK_ACC_REQUESTING:
      return {
        ...state,
        checkAccount: null,
        checkAccountRequesting: true,
        checkAccountSuccessful: false,
        checkAccountErrors: [],
      };

    case CHECK_ACC_REQUEST_SUCCESS:
      return {
        ...state,
        checkAccount: action.resData,
        checkAccountRequesting: false,
        checkAccountSuccessful: true,
      };

    case CHECK_ACC_REQUEST_ERROR:
      return {
        ...state,
        checkAccountRequesting: false,
        checkAccountSuccessful: false,
        checkAccountErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    default:
      return state;
  }
};

export default reducer;
